<ngb-alert [type]="alert.type" (closed)="closeAlert()">{{
  alert.message
}}</ngb-alert>
